import { ApplicationContext } from '@varos/client-base';
import { CallToolAggregate } from './callPartModel';
import { CallToolLoader } from './callPartInterface';
import { ChatContainerBaseConfig } from '../../base/chatBaseConfig';
import { assert } from '@varos/util-typescript';

export function createCallToolLoader(config: ChatContainerBaseConfig): CallToolLoader {
    const { repository } = config;
    return {
        useLoad(context, props) {
            // First, load the thread using the thread ID
            const threadQuery = repository.assistant.local.thread.useLookup(
                context,
                { id: props.item.message.thread },
                {
                    suspense: true,
                }
            );
            assert(threadQuery.status === 'success', 'expected suspense for thread');

            return {
                ...props.item,
                thread: threadQuery.data,
            };
        },
    };
}
